import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../../common_components/common_widgets/data-grid";
import "./index.scss";
import MdaeRadioGroup from "../../../common_components/common_widgets/radio-group";
import { toggleBillHistoryPopupVisible } from "./bill-history";
import {
  HIDE_LOADER,
  SHOW_LOADER,
} from "../../../common_components/mdae-common-reducer";
import { actions, callOperation } from "async-ops";
import { SAVE_NEW_BILLING_DATA_AS_SEEN } from "./services/save-new-billing-data-as-seen";
import { UPDATE_CASE_DETAIL_LIST_DATA } from "./reducers/case-list-reducer";
import MdaeButton from "../../../common_components/common_widgets/button";

const CaseBillingHistoryList: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const caseBillingHisotryListDataGridOptions = useMemo(() => {
    return getcaseBillingHisotryListDataGridOptions(
      props.data.data,
      props.data.data?.caseBillingHistoryList,
      dispatch
    );
  }, [props.data.data?.caseBillingHistoryList]);

  return (
    <div>
      <div>Billing History</div>
      <MdaeDataGrid {...caseBillingHisotryListDataGridOptions}></MdaeDataGrid>
    </div>
  );
};

const viewBillHistoryDetails = (dispatch, eaCaseData, eaBillingdata) => {
  const billData = {
    parent: eaCaseData,
    child: eaBillingdata,
  };
  toggleBillHistoryPopupVisible(dispatch, true, billData);
};

const markNewBillingDataAsSeen = (dispatch, eaCaseData, cellData) => {
  dispatch({ type: SHOW_LOADER });
  callOperation(SAVE_NEW_BILLING_DATA_AS_SEEN, [eaCaseData?.eaCaseId]).then(() => {
    dispatch({ type: HIDE_LOADER });
    dispatch({
      type: UPDATE_CASE_DETAIL_LIST_DATA,
      data: {
        eaCaseId: eaCaseData?.eaCaseId,
        newRecordInd: false,
      },
    });
    viewBillHistoryDetails(dispatch, eaCaseData, cellData);
  });
};

const getcaseBillingHisotryListDataGridOptions = (
  eaCaseData,
  eaCaseBillingHistoryList,
  dispatch
) => {
  const caseBillingHisotryListDataGridOption: IMdaeDataGridProps = {
    id: "pnlCaseBillingHisotryListGrid",
    className: "case-billing-history-list-grid-container",
    allowColumnResizing: true,
    dataSource: eaCaseBillingHistoryList,
    mdaeColumns: [
      {
        dataField: "caseDetailId",
        caption: "Auditable",
        dataType: "boolean",
        width: 60,
        alignment: "center",
        cellRender: (cellData) => {
          return (
            <div className={"auditable-template-container"}>
              <MdaeRadioGroup
                id="pnlBillingHistoryAuditableRadioGroup"
                items={[{ caseDetailId: cellData.data.caseDetailId }]}
                valueExpr={"caseDetailId"}
                value={
                  cellData.data.isOnAudit === true && cellData.data.caseDetailId
                }
                onValueChanged={(e) => {
                  alert("Work in progress");
                }}
              />
            </div>
          );
        },
      },
      {
        dataField: "sequence",
        caption: "Sequence",
        width: 100,
      },
      {
        dataField: "payer",
        caption: "Payer",
        width: 400,
      },
      {
        dataField: "",
        caption: "",
        width: 40,
        alignment: "center",
        cellRender: (cellData) => {
          return (
            <MdaeButton
              id=""
              role="dxButton"
              stylingMode="text"
              onContentReady={(e) => {
                $(e.component.element()).css("margin-right", "0px");
                $(e.component.element())
                  .parent("td")
                  .css({ paddingLeft: "0px", paddingRight: "0px" });
              }}
              onClick={(e) => {
                if (eaCaseData?.newRecordInd) {
                  markNewBillingDataAsSeen(dispatch, eaCaseData, cellData.data);
                } else {
                  viewBillHistoryDetails(dispatch, eaCaseData, cellData.data);
                }
              }}
            >
              <div className={"bill-history-preview-action"}>
                <i
                  style={{ height: "14px", cursor: "pointer" }}
                  className={"preview-action-icon"}
                  title="View Case"
                ></i>
              </div>
            </MdaeButton>
          );
        },
      },
      {
        dataField: "payerType",
        caption: "Payer Type",
        width: 400,
      },
      {
        dataField: "billTypeFacility",
        caption: "Bill Type Facility",
        width: 400,
      },
      {
        dataField: "totalCharges",
        caption: "Total Charges",
        width: 120,
        alignment: "right",
      },
      {
        dataField: "payment",
        caption: "Payment",
        width: 120,
        alignment: "right",
      },
    ],
  };
  return caseBillingHisotryListDataGridOption;
};

export default CaseBillingHistoryList;
